import { AvvirEvent } from "type_aliases";
import PanelType from "../../../models/domain/enums/panel_type";

export type CustomSuccessMessageDisplayedEvent = AvvirEvent<typeof CUSTOM_SUCCESS_MESSAGE_DISPLAYED, {message: string, manualClose: boolean, link?: string, panel: PanelType}>

const customSuccessMessageDisplayed = (message: string, manualClose: boolean = false, link: string = null, panel: PanelType = null): CustomSuccessMessageDisplayedEvent => ({
  type: CUSTOM_SUCCESS_MESSAGE_DISPLAYED,
  payload: {
    message,
    link,
    manualClose,
    panel
  }
});

export const CUSTOM_SUCCESS_MESSAGE_DISPLAYED = "display_custom_success_message";

export default customSuccessMessageDisplayed;
